import React, { Component } from "react";
import {
    Row,
    Col,
    FormGroup,
    ControlLabel,
    FormControl,
} from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import DatePicker from "react-datepicker";
import moment from "moment";
import {
    employmentStatusSelectOptions,
    tinClassificationSelectOptions,
    payrollClassificationSelectOptions,
} from "../../variables/Variables.jsx";
import {
    fetchEmployeeRequest,
    editEmployeeRequest,
} from "../../api/employee";
import { companySelectOptionRequest } from "../../api/company";
import { departmentSelectOptionRequest } from "../../api/department";
import { employeeTypeSelectOptionRequest } from "../../api/employeeType";
import { payscaleSelectOptionRequest } from "../../api/payscale";
import { positionSelectOptionRequest } from "../../api/position";
import CustomValuesPayroll from "components/Employees/CustomValuesPayroll.jsx";
import GovernmentLoans from "components/Employees/GovernmentLoans.jsx";
import { payLevelSelectOptionRequest } from "api/payLevel.js";
import { EmployeeAsyncSelect } from "components/EmployeeAsyncSelect/EmployeeAsyncSelect.jsx";

const formatDateOnly = (date) => date ? moment(date).format("YYYY-MM-DD") : null;
const parseDateOnly = (date) => date ? moment(date, "YYYY-MM-DD").toDate() : null;

class EmployeeForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            resource: {
                company: null,
                firstName: null,
                middleName: null,
                lastName: null,
                employeeType: null,
                employeeNumber: null,
                dateHired: null,
                dateDischarged: null,
                birthdayDate: null,
                employmentStatus: null,
                dateRegularized: null,
                tinClassification: null,
                tinNumber: null,
                sssNumber: null,
                phicNumber: null,
                hdmfNumber: null,
                ecolaNumber: null,
                payrollClassification: null,
                payLevel: null,
                superior: null,
                department: null,
                position: null,
                locationArea: null,
                locationProvince: null,
                locationCity: null,
                allowancesPerDiem: null,
                allowancesGasoline: null,
                allowancesMeal: null,
                allowancesTelephone: null,
                allowancesOperational: null,
                allowancesTransportation: null,
                allowancesHousing: null,
                allowancesOthers: null,
                monthlyCoopDeduction: null,
                monthlyEmployeeValeDeduction: null,
                monthlyUtilityBillDeduction: null,
                monthlyEducationalLoanDeduction: null,
                monthlyUniformDeduction: null,
                monthlyOtherDeduction: null,
                benefits: null,
                benefitsAccidentInsurance: false,
                benefitsHealthInsurance: false,
                benefitsBirthdayCheck: false,
                benefitsLongevityPay: false,
                benefitsMeritIncrease: false,
                benefitsRiceIncentive: false,
                benefitsSchoolBonus: false,
                benefitsSchoolAssistance: false,
                benefitsUniform: false,
                benefitsRetirementProgram: false,
                benefitsGraduationGift: false,
                benefitsLengthOfServiceIncentive: false,
                benefitsBurialAssistance: false,
                benefitsWeddingGift: false,
                benefitsAnnualSalaryReview: false,
                benefitsAnniversaryBonus: false,
                benefitsRecognitionBonus: false,
                benefitsMidYearBonus: false,
                benefitsYearEndBonus: false,
                benefitsSinulog: false,
                benefitsFlowersAndCandles: false
            },
            companySelectOptions: [],
            employeeTypeSelectOptions: [],
            payscaleSelectOptions: [],
            superiorSelectOptions: [],
            departmentSelectOptions: [],
            positionSelectOptions: [],
            activeTab: "personalInformation",
            loading: true,
            payLevelSelectOptions: [],
        };
    }

    componentDidMount() {
        const { match } = this.props;
        if (match.params.id) {
            this.fetchEmployee(match.params.id);
        }

        companySelectOptionRequest(
            (result) => this.setState({ companySelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        departmentSelectOptionRequest(
            (result) => this.setState({ departmentSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        // employeeSelectOptionRequest(
        //     (result) => this.setState({ superiorSelectOptions: result }),
        //     (error) => this.setState({ error: "There was an error" }),
        // );
        employeeTypeSelectOptionRequest(
            (result) => this.setState({ employeeTypeSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        payscaleSelectOptionRequest(
            (result) => this.setState({ payscaleSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        positionSelectOptionRequest(
            (result) => this.setState({ positionSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
        payLevelSelectOptionRequest(
            (result) => this.setState({ payLevelSelectOptions: result }),
            (error) => this.setState({ error: "There was an error" }),
        );
    }

    fetchEmployee = async (id) => {
        this.setState({ loading: true });
        await fetchEmployeeRequest(
            id,
            (result) => this.setState({ resource: result, loading: false }),
            (error) => console.log(error),
        );
    };

    handleFormChange = (e) => {
        const { target } = e;
        const { name, value } = target;

        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: value,
            },
        }));
    };

    handleCheckboxChange = (e) => {
        const { target } = e;
        const { name, checked } = target;
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [name]: checked,
            },
        }));
    };

    handleDateChange = (date, field) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                [field]: formatDateOnly(date),
            },
        }));
    };

    goToList = () => {
        this.props.history.push("/employees/list");
    };

    save = () => {
        this.setState({
            loading: true,
        });
        const { match } = this.props;
        const data = this.state.resource;

        editEmployeeRequest(
            match.params.id,
            data,
            (result) => this.saveSuccess(),
            (error) => this.saveFailure(),
        );
    };

    saveSuccess = () => {
        this.setState({
            errorMessage: null,
            successMessage: "Employee saved successfully",
            loading: false,
        });
        this.goToList();
    };

    saveFailure = () => {
        this.setState({
            errorMessage: "There was an error saving employee",
            successMessage: null,
            loading: false,
        });
    };

    changeActiveTab = (e, tabState, tadName) => {
        e.preventDefault();
        this.setState({
            [tabState]: tadName,
        });
    };

    handleChange = (employeeValue) => {
        this.setState((prevState) => ({
            resource: {
                ...prevState.resource,
                superior: employeeValue.value,
            },
        }));
    };

    render() {
        const {
            company,
            firstName,
            middleName,
            lastName,
            employeeType,
            employeeNumber,
            dateHired,
            dateDischarged,
            birthdayDate,
            employmentStatus,
            dateRegularized,
            tinClassification,
            tinNumber,
            sssNumber,
            phicNumber,
            hdmfNumber,
            ecolaNumber,
            payrollClassification,
            payLevel,
            department,
            position,
            locationArea,
            locationProvince,
            locationCity,
            allowancesPerDiem,
            allowancesGasoline,
            allowancesMeal,
            allowancesTelephone,
            allowancesOperational,
            allowancesTransportation,
            allowancesHousing,
            allowancesOthers,
            monthlyCoopDeduction,
            monthlyEmployeeValeDeduction,
            monthlyUtilityBillDeduction,
            monthlyEducationalLoanDeduction,
            monthlyUniformDeduction,
            monthlyOtherDeduction,
            benefits,
            benefitsAccidentInsurance,
            benefitsHealthInsurance,
            benefitsBirthdayCheck,
            benefitsLongevityPay,
            benefitsMeritIncrease,
            benefitsRiceIncentive,
            benefitsSchoolBonus,
            benefitsSchoolAssistance,
            benefitsUniform,
            benefitsRetirementProgram,
            benefitsGraduationGift,
            benefitsLengthOfServiceIncentive,
            benefitsBurialAssistance,
            benefitsWeddingGift,
            benefitsAnnualSalaryReview,
            benefitsAnniversaryBonus,
            benefitsRecognitionBonus,
            benefitsMidYearBonus,
            benefitsYearEndBonus,
            benefitsSinulog,
            benefitsFlowersAndCandles
        } = this.state.resource;

        const {
            companySelectOptions,
            employeeTypeSelectOptions,
            departmentSelectOptions,
            positionSelectOptions,
            activeTab,
            payLevelSelectOptions,
            loading,
        } = this.state;

        const tabs = [
            {
                title: "Personal Information",
                type: "personalInformation",
            },
            {
                title: "Custom values for Payroll",
                type: "customPayroll",
            },
            {
              title: "Government Loans",
              type: "governmentLoans",
          },
        ];

    return (
      <Row className="employee-form">
        {console.log(this.state.resource, "resource")}
        <Col md={12}>
          <Card
            title="Edit Employee"
            content={
              <form>
                <Button className="card-top-btn btn-primary" onClick={() => this.goToList()}>
                  Back to List
                </Button>
                <div className="tabs-nav" style={{marginBottom: "20px"}}>
                  {tabs.map((tab) => {
                        return (
                            <button
                              key={tab.type}
                              data-toggle="tab"
                              href="#pablo"
                              className={
                                this.state.activeTab === tab.type
                                  ? "tab-button active"
                                  : "tab-button"
                              }
                              onClick={(e) =>
                                this.changeActiveTab(
                                  e,
                                  "activeTab",
                                  tab.type
                                )
                              }
                            >
                              {tab.title}
                            </button>
                        )
                      })}
                </div>
                <section style={activeTab === "personalInformation" ? null : {display: "none"} }> 
                  <FormGroup>
                    <ControlLabel>Company</ControlLabel>
                    <FormControl 
                        readOnly
                        componentClass="select" 
                        name="company"
                        value={company && company._id}
                      >
                        
                      <option value="">N/A</option>
                      {companySelectOptions.map(option => {
                        return (
                          <option
                            key={option.value}
                            value={option.value}
                          >
                            {option.label}
                          </option>
                        );
                      })}
                    </FormControl>
                  </FormGroup>
                  <Row>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                          type="text"
                          name="firstName"
                          value={firstName}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Middle Name</ControlLabel>
                        <FormControl
                          type="text"
                          name="middleName"
                          value={middleName}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                          type="text"
                          name="lastName"
                          value={lastName}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Birthday</ControlLabel>
                        <DatePicker
                          selected={parseDateOnly(birthdayDate)}
                          onChange={(date) => this.handleDateChange(date,'birthdayDate')}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          placeholderText=""
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Employee Type</ControlLabel>
                        <FormControl 
                            readOnly
                            componentClass="select" 
                            name="employeeType"
                            value={employeeType && employeeType._id}
                          >
                          <option value="">N/A</option>
                          {employeeTypeSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Employment Status</ControlLabel>
                        <FormControl 
                            onChange={this.handleFormChange}
                            componentClass="select" 
                            name="employmentStatus"
                            value={employmentStatus}
                          >
                          <option value="">Select</option>
                          {employmentStatusSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Payroll Classification</ControlLabel>
                        <FormControl 
                            readOnly
                            componentClass="select" 
                            name="company"
                            value={company && company._id}
                        >
                          <option value="">N/A</option>
                          {companySelectOptions.map(
                              (option) => {
                                  return (
                                      <option
                                          key={option.value}
                                          value={option.value}
                                      >
                                          {option.label}
                                      </option>
                                  );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Pay Level</ControlLabel>
                        <FormControl 
                            readOnly
                            componentClass="select" 
                            name="payLevel"
                            value={payLevel ? payLevel._id : ''}
                          >
                            {console.log(payLevel)}
                          <option value="">N/A</option>
                          {payLevelSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Employee Number</ControlLabel>
                        <FormControl
                          type="text"
                          name="employeeNumber"
                          value={employeeNumber}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Date Hired</ControlLabel>
                        <DatePicker
                          selected={parseDateOnly(dateHired)}
                          onChange={(date) => this.handleDateChange(date,'dateHired')}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          placeholderText=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Date Discharged</ControlLabel>
                        <DatePicker
                          selected={parseDateOnly(dateDischarged)}
                          onChange={(date) => this.handleDateChange(date,'dateDischarged')}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          placeholderText=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-3">
                      <FormGroup>
                        <ControlLabel>Date Regularized</ControlLabel>
                        <DatePicker
                          selected={parseDateOnly(dateRegularized)}
                          onChange={(date) => this.handleDateChange(date,'dateRegularized')}
                          dateFormat="MM/dd/yyyy"
                          className="form-control"
                          showYearDropdown
                          dropdownMode="select"
                          maxDate={new Date()}
                          placeholderText=""
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>TIN Classification</ControlLabel>
                        <FormControl 
                            onChange={this.handleFormChange}
                            componentClass="select" 
                            name="tinClassification"
                          value={tinClassification}
                          >
                          <option value="">Select</option>
                          {tinClassificationSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>TIN Number</ControlLabel>
                        <FormControl
                          type="text"
                          name="tinNumber"
                          value={tinNumber}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>PHIC Number</ControlLabel>
                        <FormControl
                          type="text"
                          name="phicNumber"
                          value={phicNumber}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>SSS Number</ControlLabel>
                        <FormControl
                          type="text"
                          name="sssNumber"
                          value={sssNumber}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>HDMF Number</ControlLabel>
                        <FormControl
                          type="text"
                          name="hdmfNumber"
                          value={hdmfNumber}
                          onChange={this.handleFormChange}
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-6">
                      <FormGroup>
                        <ControlLabel>ECOLA</ControlLabel>
                        <FormControl
                          type="text"
                          name="ecolaNumber"
                          value={ecolaNumber}
                          readOnly
                          placeholder=""
                        />
                      </FormGroup>
                    </div>
                  </Row>
                  <Row>
                    <div className="col-md-4">
                      <FormGroup>
                        <ControlLabel>Superior</ControlLabel>
                        <EmployeeAsyncSelect
                            onChange={this.handleChange}
                            placeholder="Select Superior"
                            disabled={true}
                        />

                      </FormGroup>
                    </div>
                    <div className="col-md-4">
                      <FormGroup>
                        <ControlLabel>Department</ControlLabel>
                        <FormControl 
                            readOnly
                            componentClass="select" 
                            name="department"
                            value={department && department._id}
                          >
                          <option value="">N/A</option>
                          {departmentSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                    <div className="col-md-4">
                      <FormGroup>
                        <ControlLabel>Position</ControlLabel>
                        <FormControl 
                            readOnly
                            componentClass="select" 
                            name="position"
                            value={position && position._id}
                          >
                          <option value="">N/A</option>
                          {positionSelectOptions.map(option => {
                            return (
                              <option
                                key={option.value}
                                value={option.value}
                              >
                                {option.label}
                              </option>
                            );
                          })}
                        </FormControl>
                      </FormGroup>
                    </div>
                  </Row>
                  <Row
                    style={{
                      margin: '0 auto 15px',
                      padding: '10px 25px',
                      border: '1px solid #999',
                      borderRadius: '5px',
                      display: 'inline-block',
                      width: '100%'
                    }}
                  >
                      <div className="col-md-12">
                        <h6>
                          Work Location
                        </h6>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                            <ControlLabel>Area</ControlLabel>
                            <FormControl
                              type="text"
                              name="locationArea"
                              value={locationArea}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <ControlLabel>Province</ControlLabel>
                          <FormControl
                            type="text"
                            name="locationProvince"
                            value={locationProvince}
                            readOnly
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                      <div className="col-md-4">
                        <FormGroup>
                          <ControlLabel>City</ControlLabel>
                          <FormControl
                            type="text"
                            name="locationCity"
                            value={locationCity}
                            readOnly
                            placeholder=""
                          />
                        </FormGroup>
                      </div>
                  </Row>
                  <Row
                    style={{
                      margin: '0 auto 15px',
                      padding: '10px 25px',
                      border: '1px solid #999',
                      borderRadius: '5px',
                      display: 'inline-block',
                      width: '100%'
                    }}
                  >
                      <div className="col-md-12">
                        <h6>
                          Allowances
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Per Diem</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesPerDiem"
                              value={allowancesPerDiem}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Gasoline</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesGasoline"
                              value={allowancesGasoline}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Meal (per day)</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesMeal"
                              value={allowancesMeal}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Telephone</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesTelephone"
                              value={allowancesTelephone}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Operational Expenses</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesOperational"
                              value={allowancesOperational}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Transportation</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesTransportation"
                              value={allowancesTransportation}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Housing</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesHousing"
                              value={allowancesHousing}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Others</ControlLabel>
                            <FormControl
                              type="text"
                              name="allowancesOthers"
                              value={allowancesOthers}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                    </Row>
                    <Row
                      style={{
                        margin: '0 auto 15px',
                        padding: '10px 25px',
                        border: '1px solid #999',
                        borderRadius: '5px',
                        display: 'inline-block',
                        width: '100%'
                      }}
                    >
                      <div className="col-md-12">
                        <h6>
                          Monthly Deductions
                        </h6>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Coop</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyCoopDeduction"
                              value={monthlyCoopDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Employee Vale</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyEmployeeValeDeduction"
                              value={monthlyEmployeeValeDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Utility Bill</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyUtilityBillDeduction"
                              value={monthlyUtilityBillDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Educational Loan</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyEducationalLoanDeduction"
                              value={monthlyEducationalLoanDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Other monthly deductions</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyOtherDeduction"
                              value={monthlyOtherDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                      <div className="col-md-3">
                        <FormGroup>
                            <ControlLabel>Uniform</ControlLabel>
                            <FormControl
                              type="text"
                              name="monthlyUniformDeduction"
                              value={monthlyUniformDeduction}
                              readOnly
                              placeholder=""
                            />
                          </FormGroup>
                      </div>
                    </Row>
                    <FormGroup>
                      <ControlLabel>Benefits</ControlLabel>
                      <FormControl 
                          readOnly
                          componentClass="select" 
                          name="benefits"
                          value={benefits}
                        >
                        <option value="">N/A</option>
                        <option value="companyPolicy">Company Policy</option>
                        <option value="specialBenefits">Special Benefits</option>
                      </FormControl>
                    </FormGroup>
                    {benefits === 'specialBenefits' &&
                      <Row
                        style={{
                          margin: '0 auto 15px',
                          padding: '10px 25px',
                          border: '1px solid #999',
                          borderRadius: '5px',
                          display: 'inline-block',
                          width: '100%',
                          backgroundColor: '#F5F5F5',
                          color: '#888888',
                          cursor: 'not-allowed',
                        }}
                      >
                        <div className="col-md-12">
                          <h6>
                            Special Benefits
                          </h6>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsAccidentInsurance}
                                name="benefitsAccidentInsurance"
                                readOnly />
                                Accident Insurance
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsHealthInsurance}
                                name="benefitsHealthInsurance"
                                readOnly />
                                Health Insurance
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsBirthdayCheck}
                                name="benefitsBirthdayCheck"
                                readOnly />
                                Birthday Check
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsLongevityPay}
                                name="benefitsLongevityPay"
                                readOnly />
                                Longevity Pay
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsMeritIncrease}
                                name="benefitsMeritIncrease"
                                readOnly />
                                Merit Increase
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsRiceIncentive}
                                name="benefitsRiceIncentive"
                                readOnly />
                                Rice Incentive
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsSchoolBonus}
                                name="benefitsSchoolBonus"
                                readOnly />
                                School Bonus
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsSchoolAssistance}
                                name="benefitsSchoolAssistance"
                                readOnly />
                                School Assistance
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsUniform}
                                name="benefitsUniform"
                                readOnly />
                                Uniform
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsRetirementProgram}
                                name="benefitsRetirementProgram"
                                readOnly />
                                Retirement Program
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsGraduationGift}
                                name="benefitsGraduationGift"
                                readOnly />
                                Graduation Gift
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsLengthOfServiceIncentive}
                                name="benefitsLengthOfServiceIncentive"
                                readOnly />
                                Length Of Service Incentive
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsBurialAssistance}
                                name="benefitsBurialAssistance"
                                readOnly />
                                Burial Assistance
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsWeddingGift}
                                name="benefitsWeddingGift"
                                readOnly />
                                Wedding Gift
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsAnnualSalaryReview}
                                name="benefitsAnnualSalaryReview"
                                readOnly />
                                Annual Salary Review
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsAnniversaryBonus}
                                name="benefitsAnniversaryBonus"
                                readOnly />
                                Anniversary Bonus
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsRecognitionBonus}
                                name="benefitsRecognitionBonus"
                                readOnly />
                                Recognition Bonus
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsMidYearBonus}
                                name="benefitsMidYearBonus"
                                readOnly />
                                Mid Year Bonus
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsYearEndBonus}
                                name="benefitsYearEndBonus"
                                readOnly />
                                Year End Bonus
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsSinulog}
                                name="benefitsSinulog"
                                readOnly />
                                Sinulog
                            </label>
                        </div>
                        <div className="formCheckbox">
                            <label>
                            <input 
                                type="checkbox" 
                                defaultChecked={benefitsFlowersAndCandles}
                                name="benefitsFlowersAndCandles"
                                readOnly />
                                Flowers And Candles
                            </label>
                        </div>
                      </Row>
                    }
                    <Button bsStyle="primary" pullRight fill onClick={this.save} disabled={loading}>
                      {loading ? 'Saving...' : 'Save Changes'}
                    </Button>
                    <div className="clearfix" />
                </section>
                <section style={activeTab === "customPayroll" ? null : {display: "none"} }>
                  {
                    this.state.resource ? 
                    <CustomValuesPayroll 
                      employee={this.state.resource} 
                      fetchEmployee={this.fetchEmployee}
                      loading={this.state.loading}
                    /> : null
                  }
                </section>
                <section style={activeTab === "governmentLoans" ? null : {display: "none"} }>
                  {
                    this.state.resource ? 
                    <GovernmentLoans 
                      employee={this.state.resource} 
                      fetchEmployee={this.fetchEmployee}
                      loading={this.state.loading}
                    /> : null
                  }
                </section>
              </form>
            }
          />
        </Col>
      </Row>
    )
  }
}

export default EmployeeForm;
